export var WebMerchantMenuItemTypeEnum;
(function (WebMerchantMenuItemTypeEnum) {
    WebMerchantMenuItemTypeEnum["LOCATION"] = "LOCATION";
    WebMerchantMenuItemTypeEnum["LOYALTY_GROGRAM"] = "LOYALTY_GROGRAM";
    WebMerchantMenuItemTypeEnum["ORDER_AND_FAVORITE"] = "ORDER_AND_FAVORITE";
    WebMerchantMenuItemTypeEnum["MY_ADDRESSES"] = "MY_ADDRESSES";
    WebMerchantMenuItemTypeEnum["NOTIFICATION_SETTINGS"] = "NOTIFICATION_SETTINGS";
    WebMerchantMenuItemTypeEnum["HELP"] = "HELP";
    WebMerchantMenuItemTypeEnum["MY_ORDERS"] = "MY_ORDERS";
})(WebMerchantMenuItemTypeEnum || (WebMerchantMenuItemTypeEnum = {}));
//# sourceMappingURL=web-merchant-components.js.map